var React = require('react');

function DownloadInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"#000","strokeWidth":"2"},[React.createElement("path",{"d":"M12 21V9","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M15 19l-3 3-3-3M5.4 15.5a7.3 7.3 0 0 1-3.4-6C2 5.2 5.6 2 10 2c3 0 5.6 1.5 7 3.8 2.8.4 5 2.7 5 5.5 0 2-1.1 3.7-2.8 4.7","key":1})]));
}

DownloadInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
